export default __webpack_public_path__ + "0f5f2bb14145630d48014890cf03452a.svg";